export default __webpack_public_path__ + "static/daria-59b82a981eb5bedfd579e06a74a32c09.png";